import {TabbedForm as RaTabbedForm, TabbedFormProps} from "react-admin";
import {ComponentType} from "react";
import Toolbar from "./Toolbar";
import type {SxProps, Theme} from '@mui/system';

const toolbar = <Toolbar/>
const TabbedForm: ComponentType<TabbedFormProps> & {Tab: ComponentType<any>} = (props) => {

  return <RaTabbedForm toolbar={toolbar} {...props} sx={[{

        "& .MuiCardContent-root": {
            p: {
                xs: 2,
                sm: 3,
                lg: 4
            },
        },
        '& .MuiTabs-flexContainer': {
            px: (theme) => (theme as Theme).spacing(4)
        }

    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    }, props.sx as SxProps]}/>
}


TabbedForm.Tab = RaTabbedForm.Tab;

export default TabbedForm
